import { REPORT_TYPES } from '@repo/constants'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/_auth/_modules/_app/reports/material')({
  staticData: {
    title: REPORT_TYPES.MATERIAL,
    crumb: REPORT_TYPES.MATERIAL,
    permissions: ['reports_view_material'],
  },
  beforeLoad: async ({ context }) => {
    context.handleRoutePermissions(Route)
  },
})
